<span class="trading-breadcrumb">
  <p-breadcrumb *ngIf="orgType===OrgType.Vendor" [model]="breadcrumb"></p-breadcrumb>
  <p-breadcrumb *ngIf="orgType===OrgType.Customer" [model]="breadcrumb"></p-breadcrumb>
</span>

<h1 *ngIf="orgType===OrgType.Vendor">Vendor Summary</h1>
<h1 *ngIf="orgType===OrgType.Customer">Customer Summary</h1>

<main class="tradingPartnerSummary">
  <div *ngIf="orgType===OrgType.Vendor" class="page-help-topics">
    <button pButton type="button" class="icon-action" icon="fa fa-question-circle" pTooltip="View Help Topics" tooltipPosition="top"
            (click)="help.toggle($event)"></button>
    <p-overlayPanel #help styleClass="page-help-interior">
      <h4 style="margin-bottom:5px;"><i class="fa fa-question-circle"></i> Help Topics</h4>
      <ul>
        <div>
          <ul>
            <li>
              <a (click)="helpVendorsOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpVendorsAdd=true">How do I add vendors?</a>
            </li>
            <li>
              <a (click)="helpVendorsManage=true">How do I manage contacts, payment terms, and info?</a>
            </li>
            <li>
              <a (click)="helpVendorsTransactions=true">How do I manage vendor transactions?</a>
            </li>
          </ul>
        </div>
      </ul>
    </p-overlayPanel>
    <!-- Vendor Setup -->
    <p-dialog header="Show Me | Vendors: Overview" [(visible)]="helpVendorsOverview" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpVendorsOverview" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=0;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Vendors: Adding Vendors" [(visible)]="helpVendorsAdd" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpVendorsAdd" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=106;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Vendors: Contacts, Payments &amp; Info" [(visible)]="helpVendorsManage" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpVendorsManage" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=240;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Vendors: Transactions " [(visible)]="helpVendorsTransactions" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpVendorsTransactions" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=513;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </p-dialog>
  </div>

  <div class="page-help-topics" *ngIf="orgType==OrgType.Customer">
    <button pButton type="button" class="icon-action" icon="fa fa-question-circle" pTooltip="View Help Topics" tooltipPosition="top"
            (click)="help.toggle($event)"></button>
    <p-overlayPanel #help styleClass="page-help-interior">
      <h4 style="margin-bottom:5px;"><i class="fa fa-question-circle"></i> Help Topics</h4>
      <ul>
        <div>
          <ul>
            <li>
              <a (click)="helpCustomersOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpCustomersSetup=true">How do I setup a customer?</a>
            </li>
            <li>
              <a (click)="helpCustomersContacts=true">How do I add contacts?</a>
            </li>
            <li>
              <a (click)="helpCustomersPayments=true">How do I add payment terms?</a>
            </li>
            <li>
              <a (click)="helpCustomersSalesTax=true">How do I add sales tax?</a>
            </li>
          </ul>
        </div>
      </ul>
    </p-overlayPanel>
    <!-- Customer Setup -->
    <p-dialog header="Show Me | Customer Setup: Overview" [(visible)]="helpCustomersOverview" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpCustomersOverview" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=0;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Customer Setup: Setup a Customer" [(visible)]="helpCustomersSetup" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpCustomersSetup" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=30;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Customer Setup: Adding Contacts" [(visible)]="helpCustomersContacts" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpCustomersContacts" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=216;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Customer Setup: Payment Terms" [(visible)]="helpCustomersPayments" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpCustomersPayments" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=239;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Customer Setup: Sales Tax" [(visible)]="helpCustomersSalesTax" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpCustomersSalesTax" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=274;autoplay=1" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
  </div>

  <div *ngIf="orgType===OrgType.Vendor" class="instruction-text">Manage information for your organization's vendors.</div>
  <div *ngIf="orgType===OrgType.Customer" class="instruction-text">Manage information for your organization's customers.</div>

  <section class="comp-orgSummary">
    <p-tabView (onChange)="onChangeTab($event.index)">
      <p-tabPanel header="Manage">

        <app-data-table [columns]="partnerTableColumns" [value]="partnerSummaries" sortField="businessName" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                        [leftCaptionTemplate]="partnerLeftCaptionTemplate" [rightCaptionTemplate]="partnerRightCaptionTemplate" [bodyTemplate]="partnerBodyTemplate">
          <ng-template #partnerLeftCaptionTemplate>
            <p-selectButton [options]="viewOptionsactive"  [(ngModel)]="getActivePartners" (onChange)="onChangeActivePartners($event.value)"></p-selectButton>
          </ng-template>
          <ng-template #partnerRightCaptionTemplate>
            <div *ngIf="orgType===OrgType.Vendor">
              <button pButton type="button" class="action-secondary" [routerLink]="[RouteLink.TradingPartner, orgType]" routerLinkActive="active"
                      icon="fa fa-plus" label="Vendor">
              </button>
            </div>
            <div *ngIf="orgType===OrgType.Customer">
              <button pButton type="button" class="action-secondary" [routerLink]="[RouteLink.TradingPartner, orgType]" routerLinkActive="active"
                      icon="fa fa-plus" label="Customer">
              </button>
            </div>
          </ng-template>
          <ng-template #partnerBodyTemplate let-row="row" let-columns="columns">
            <tr>
              <td *ngFor="let col of columns" [ngSwitch]="col.field">
                <span class="p-column-title">{{col.header}}</span>
                <span class="p-cell">
                  <div *ngSwitchCase="'businessName'">
                    <a [routerLink]="[RouteLink.TradingPartner, row.id, orgType]">{{row.businessName}}</a>
                  </div>
                  <div *ngSwitchCase="'currentStatus'">
                    <app-approvable-status [transaction]="transaction" [refId]="row.id" [currentStatus]="row.currentStatus"
                                           [hasSubmissionError]="row.hasSubmissionError">
                    </app-approvable-status>
                  </div>
                  <div *ngSwitchCase="'active'">
                    {{row.active | boolean}}
                  </div>
                  <div *ngSwitchCase="'action'">
                    <button pButton icon="fa fa-users" class="action-secondary" pTooltip="Contacts" tooltipPosition="top"
                            [routerLink]="[RouteLink.TradingPartner, row.id, orgType, TradingPartnerTabIndex.ContactTab]" routerLinkActive="active">
                    </button>
                    <button pButton icon="fa fa-comments" class="action-secondary" pTooltip="Correspondence" tooltipPosition="top"
                            [routerLink]="[RouteLink.TradingPartner, row.id, orgType, TradingPartnerTabIndex.CorrespondenceTab]" routerLinkActive="active">
                    </button>
                    <button pButton icon="fa fa-tasks" class="action-secondary" pTooltip="ToDo" tooltipPosition="top"
                            [routerLink]="[RouteLink.TradingPartner, row.id, orgType, TradingPartnerTabIndex.ToDoTab]" routerLinkActive="active">
                    </button>
                    <button *ngIf="orgType===OrgType.Customer"
                            pButton icon="fa fa-paperclip" class="action-secondary" pTooltip="Attachment C"
                            tooltipPosition="top" [routerLink]="[RouteLink.TradingPartner, row.id, orgType, TradingPartnerTabIndex.CustomerAttachmentTab]" routerLinkActive="active">
                    </button>
                    <button *ngIf="orgType===OrgType.Vendor"
                            pButton icon="fa fa-paperclip" class="action-secondary" pTooltip="Attachment V"
                            tooltipPosition="top" [routerLink]="[RouteLink.TradingPartner, row.id, orgType, TradingPartnerTabIndex.VendorAttachmentTab]" routerLinkActive="active">
                    </button>
                    <button *ngIf="row.currentTxnStatus?.deleteEnabled"
                            pButton class="icon-negative" icon="fa fa-trash" (click)="onClickDeletePartner(row)">
                    </button>
                  </div>
                  <div *ngSwitchDefault>{{row[col.field]}}</div>
                </span>
              </td>
            </tr>
          </ng-template>
        </app-data-table>

      </p-tabPanel>

      <p-tabPanel header="Transactions">
        <div style="text-align:left;margin: 15px 0px 10px 0;">
          <button pButton class="action-secondary" (click)="toggleSearch()" icon="fa fa-search" label="Search"></button>
        </div>

        <!-- search panel for transactions tab -->
        <div *ngIf="showSearch" class="searchPanel">
          <div class="p-grid">
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label> Transaction Type</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="transactionType" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [showClear]="true"
                              [options]="txnTypeDropDown"
                              [(ngModel)]="searchTxn.transactionType"></p-dropdown>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label> Company Name</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-autoComplete name="businessName" class="autoComplete" field="businessName" [placeholder]="PrimeNgConfig.AutoCompletePlaceholder"
                                  [suggestions]="searchTxnAutoCompleteOptions" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true" [dropdown]="true"
                                  [(ngModel)]="searchTxn"
                                  (completeMethod)="searchPartner($event.query)"
                                  (onSelect)="onSelectBusinessName()"></p-autoComplete>

                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label> Last</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="numberOfDays" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [showClear]="true"
                              [options]="daysDropDown"
                              [(ngModel)]="searchTxn.numberOfDays"></p-dropdown>
                  <span style="position:relative;top:5px;left:5px">Days</span>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Starting Date</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-calendar name="startingDate" [dateFormat]="Format.PcalendarDate" [placeholder]="PrimeNgConfig.CalendarPlaceholder" [showIcon]="true"
                              [monthNavigator]="true" [yearNavigator]="true" [yearRange]="YearRange" [style]="{'overflow':'visible'}"
                              [(ngModel)]="startingDate"
                              (onSelect)="onSelectStartingDate($event)"></p-calendar>&nbsp;
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label> Ending Date</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-calendar name="endDate" dataType="string" [dateFormat]="Format.PcalendarDate" [placeholder]="PrimeNgConfig.CalendarPlaceholder" [showIcon]="true"
                              [monthNavigator]="true" [yearNavigator]="true" [yearRange]="YearRange" [style]="{'overflow':'visible'}"
                              [(ngModel)]="endingDate"
                              (onSelect)="onSelectEndingDate($event)"
                              [disabled]="disabledEndDate"></p-calendar>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-md-12 p-lg-12">
              <div class="p-grid">
                <div class="p-col-12 p-md-2 p-lg-2"></div>
                <div class="p-col-12 p-md-10 p-lg-10">
                  <button pButton class="inaction-secondary" icon="fa fa-eraser" label="Clear"
                          (click)="onClickClearSearchTransaction()"></button>
                  <button pButton class="action-secondary" icon="fa fa-search" label="Go"
                          (click)="onClickSearchTransaction()"></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <app-data-table [columns]="transactionTableColumns" [value]="transactionSummaries" sortField="transactionType" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                        [leftCaptionTemplate]="transLeftCaptionTemplate" [bodyTemplate]="transBodyTemplate">

          <ng-template #transLeftCaptionTemplate>
            <p-selectButton name="governmentAgency" [options]="viewOptionsactive" [(ngModel)]="getActiveTransactions" (onChange)="onChangeActiveTransaction($event.value)"></p-selectButton>
          </ng-template>

          <ng-template #transBodyTemplate let-row="row" let-columns="columns">
            <tr>
              <td *ngFor="let col of columns" [ngSwitch]="col.field">
                <span class="p-column-title">{{col.header}}</span>
                <span class="p-cell">
                  <div *ngSwitchCase="'transactionType'">
                    {{row.transactionType | titleCase }}
                  </div>
                  <div *ngSwitchCase="'active'">
                    {{row.active | boolean }}
                  </div>
                  <div *ngSwitchCase="'docNumber'">
                    <a style="color:blue;" (click)="openPOPdf(row)">{{row.docNumber}}</a>
                  </div>
                  <div *ngSwitchCase="'date'">
                    {{row.date | date: Format.Date}}
                  </div>
                  <div *ngSwitchCase="'uniqueChargeCodes'">
                    <span *ngIf="row.uniqueChargeCodes">
                      <span *ngIf="row.uniqueChargeCodes.length===1">
                        {{ row.uniqueChargeCodes[0].chargeNumber }}
                      </span>
                      <span *ngIf="row.uniqueChargeCodes.length > 1" align="center">
                        <app-show-charge-code [chargeCodes]="row.uniqueChargeCodes"></app-show-charge-code>
                      </span>
                    </span>
                  </div>
                  <div *ngSwitchCase="'amount'">
                    {{row.amount | currency:Format.Currency}}
                  </div>
                  <div *ngSwitchDefault>{{row[col.field]}}</div>
                </span>
              </td>
            </tr>
          </ng-template>
        </app-data-table>

      </p-tabPanel>
    </p-tabView>

    <p-confirmDialog></p-confirmDialog>

  </section>
</main>
